import React, { Component, Fragment } from 'react';
import { isEmpty, size } from 'lodash';

import Pagination from '../../../container/MUI/Pagination';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
import AccessTypeForm, { PAGES } from './AccessTypeForm';

import { ArrowDropDown, EditRounded, ExpandLess, ExpandMore, DeleteRounded } from '@mui/icons-material';
import { withStyles } from '@mui/styles';

import { 
    IconButton, 
    Button,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse, 
    Box,
    Container
} from '@mui/material';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
    marginBottom: theme.spacing(1),
    backgroundColor: "cornsilk",
  },
  nested2: {
    paddingLeft: theme.spacing(8),
  },
});

const orderByAsc = (list, field) => {
    list.sort( (a, b) => {
        if (a[field] > b[field]) return 1;
        if (b[field] > a[field]) return -1;

        return 0;
    })
    return list
}

class AccessList extends Component {
    state = { 
        openAccessForm: false,
        updateAccess: false,
        deleteAccess: false,
        selectedAccess: {},
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.ACCESS)){
            this.props.fetchAccess()
        }
    }

    handleClose = () => {
        this.setState({ 
            openAccessForm: false,
            updateAccess: false,
            deleteAccess: false,
            selectedAccess: {},
        });
    };    

    handleDelete = async () => {
        const { toDelete } = this.state;
        await this.props.deleteAccess(toDelete)
        if(this.props.STATE.access.error){
            // this.props.notif("error", "ERROR")
            this.props.notif("error", this.props.STATE.access.error)
        } else {
            
            this.props.notif("success", "Accès supprimé")
            this.setState({
                deleteAccess: false,
                toDelete: {},
            })
        }
    }

    getAccessList = () => {
        const { ACCESS, classes } = this.props;

        if (!isEmpty(ACCESS)){
            let list = orderByAsc(Object.values(ACCESS), "access_name")
            
            return list.map(item => (
                    <Fragment key={item.access_id}>
                        <ListItem>
                            <ListItemText primary={item.access_name.toUpperCase()} />
                            <IconButton 
                                onClick={ () => this.setState({
                                    updateAccess: true,
                                    selectedAccess: item
                                }) }
                            >
                                <EditRounded />
                            </IconButton>
                            <IconButton 
                                onClick={ () => this.setState({
                                    deleteAccess: true,
                                    toDelete: item
                                }) }
                            >
                                <DeleteRounded />
                            </IconButton>
                            <IconButton
                                title="Liste des pages"
                                onClick={ () => this.setState({
                                    [item.access_id]: !this.state[item.access_id]
                                }) } 
                            >
                                {this.state[item.access_id] ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </ListItem>
                        
                        {this.state[item.access_id] && 
                            item.access_pages.map( page => (
                                <Collapse
                                    key={page}
                                    in={true} 
                                    timeout="auto" 
                                    unmountOnExit
                                >
                                    <List component="div" disablePadding >
                                        <ListItem
                                            className={classes.nested}
                                        >
                                            <ListItemText primary={PAGES[page]} />                            
                                        </ListItem>
                                    </List>
                                </Collapse>
                            ) )
                        }                        
                    </Fragment>
                )
            )
        }
    }
    render() {

        const { page, rowsPerPage, deleteAccess, toDelete, updateAccess, selectedAccess, openAccessForm } = this.state;
        const { classes } = this.props;
        
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Box>
                <Container maxWidth="lg">
                {openAccessForm &&
                    <AccessTypeForm handleClose={this.handleClose} {...this.props} />
                }
                {deleteAccess && !isEmpty(toDelete) &&
                    <DeleteDialog
                        title={"l'accès"}
                        open={true}
                        close={() => this.setState({ deleteAccess: false, toDelete: {} })}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                    />
                }
                {updateAccess && selectedAccess && 
                    <AccessTypeForm update access={selectedAccess} handleClose={this.handleClose} {...this.props} />
                }
                
                <Typography variant="h6" id="tableTitle">
                    Liste des Accès
                </Typography>
                
                <Box p={1} style={{textAlign: "right"}}>
                    <Button variant="contained" 
                        onClick={() => this.setState({openAccessForm: true})} 
                        color="primary"
                        title="Nouvel Accès">
                        Créer un Accès
                    </Button>
                </Box>

                    <List
                        style={{maxWidth: "inherit"}}
                        component="div"
                        aria-labelledby="nested-list-subheader"
                        className={classes.root}
                    >
                        {this.getAccessList()}
                    </List>
                    
                </Container>
            </Box>
        );
    }
}

export default withStyles(styles)(AccessList);